<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-模拟显示-轮播图
    -->
    <div class="drag optional" @click.stop="$parent.$parent.onEditer(index)" :class="{selected: index === selectedIndex}">
      <div class="diy-banner" :class="{selected: index === selectedIndex}" 
      >
        <div class="img-list" >
         
          <div v-if="item.params.type == '3'" style="display: flex;width: 100%;">
            <div :key="index" style="margin-left: 20px;" v-for="(hotvideo, index) in item.data">
                {{hotvideo.name  }}
            </div>
            <div style="clear: both;"></div>
          </div>
          库存
  
         
          <div v-if="item.params.type == '1'" style="display: flex;">
            <img v-img-url="hotvideo.image" 
              style="width: 358px;margin-left: 2%;border-radius: 8px;"
            :key="index" v-for="(hotvideo, index) in item.data" v-if="index <= 2">
            <div style="clear: both;"></div>
          </div>
     
          
        
        
        </div>
        
      </div>
      <div class="btn-edit-del">
        <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['item', 'index', 'selectedIndex'],
    methods: {

    }
  };
</script>

<style scoped>
.diy-banner{ height: 200px; overflow: hidden;}
.diy-banner img{width: 100%; height: 200px; object-fit: fill;}
.img-list {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/Inventory.vue